import LogRocket from "logrocket";
type Identify = typeof LogRocket.identify;
export const logRocket = {
  init() {
    if (import.meta.env.MODE !=="staging") return;
    const logRocketSlug = import.meta.env.LOGROCKET_SLUG;
    const logRocketProject = import.meta.env.LOGROCKET_PROJECT;
    if (logRocketSlug && logRocketProject) {
      LogRocket.init(`${logRocketSlug}/${logRocketProject}`, {
        network: {
          requestSanitizer(request) {
            if (request.method === "POST") {
              request.body = "redact";
            }
            return request;
          },
        },
        mergeIframes: true,
        childDomains: ["sinecycle-customers.s3.us-east-2.amazonaws.com"],
      });
    }
  },
  logSessionURL() {
    if (import.meta.env.MODE !=="staging") return;
    LogRocket.getSessionURL((sessionURL) => {});
  },
  getSessionURL(): Promise<string> {
    if (import.meta.env.MODE !=="staging") return Promise.resolve("");
    return new Promise((resolve) => {
      LogRocket.getSessionURL((sessionURL) => resolve(sessionURL));
    });
  },
  track(trackingItem: string) {
    if (import.meta.env.MODE !=="staging") return;
    LogRocket.track(trackingItem);
  },
  identify(uid: string, traits: Parameters<Identify>[0]) {
    if (import.meta.env.MODE !=="staging") return;
    LogRocket.identify(uid, traits);
  },
  startNewSession() {
    if (import.meta.env.MODE !=="staging") return;
    LogRocket.startNewSession();
  },
};
